import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { 
  Wrench, User, Phone, Mail, MapPin, Building2, 
  CheckCircle, ArrowRight, ArrowLeft, Shield, Star,
  Zap, Settings, FileText, Camera, DollarSign
} from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Türkiye illeri
const CITIES = [
  'Adana', 'Adıyaman', 'Afyonkarahisar', 'Ağrı', 'Aksaray', 'Amasya', 'Ankara', 'Antalya', 
  'Ardahan', 'Artvin', 'Aydın', 'Balıkesir', 'Bartın', 'Batman', 'Bayburt', 'Bilecik', 
  'Bingöl', 'Bitlis', 'Bolu', 'Burdur', 'Bursa', 'Çanakkale', 'Çankırı', 'Çorum', 
  'Denizli', 'Diyarbakır', 'Düzce', 'Edirne', 'Elazığ', 'Erzincan', 'Erzurum', 'Eskişehir',
  'Gaziantep', 'Giresun', 'Gümüşhane', 'Hakkari', 'Hatay', 'Iğdır', 'Isparta', 'İstanbul',
  'İzmir', 'Kahramanmaraş', 'Karabük', 'Karaman', 'Kars', 'Kastamonu', 'Kayseri', 'Kırıkkale',
  'Kırklareli', 'Kırşehir', 'Kilis', 'Kocaeli', 'Konya', 'Kütahya', 'Malatya', 'Manisa',
  'Mardin', 'Mersin', 'Muğla', 'Muş', 'Nevşehir', 'Niğde', 'Ordu', 'Osmaniye',
  'Rize', 'Sakarya', 'Samsun', 'Şanlıurfa', 'Siirt', 'Sinop', 'Şırnak', 'Sivas',
  'Tekirdağ', 'Tokat', 'Trabzon', 'Tunceli', 'Uşak', 'Van', 'Yalova', 'Yozgat', 'Zonguldak'
];

// İlçe verileri
const DISTRICTS = {
  'İstanbul': ['Adalar', 'Arnavutköy', 'Ataşehir', 'Avcılar', 'Bağcılar', 'Bahçelievler', 'Bakırköy', 'Başakşehir', 'Bayrampaşa', 'Beşiktaş', 'Beykoz', 'Beylikdüzü', 'Beyoğlu', 'Büyükçekmece', 'Çatalca', 'Çekmeköy', 'Esenler', 'Esenyurt', 'Eyüpsultan', 'Fatih', 'Gaziosmanpaşa', 'Güngören', 'Kadıköy', 'Kağıthane', 'Kartal', 'Küçükçekmece', 'Maltepe', 'Pendik', 'Sancaktepe', 'Sarıyer', 'Silivri', 'Sultanbeyli', 'Sultangazi', 'Şile', 'Şişli', 'Tuzla', 'Ümraniye', 'Üsküdar', 'Zeytinburnu'],
  'Ankara': ['Akyurt', 'Altındağ', 'Ayaş', 'Bala', 'Beypazarı', 'Çamlıdere', 'Çankaya', 'Çubuk', 'Elmadağ', 'Etimesgut', 'Evren', 'Gölbaşı', 'Güdül', 'Haymana', 'Kahramankazan', 'Kalecik', 'Keçiören', 'Kızılcahamam', 'Mamak', 'Nallıhan', 'Polatlı', 'Pursaklar', 'Sincan', 'Şereflikoçhisar', 'Yenimahalle'],
  'İzmir': ['Aliağa', 'Balçova', 'Bayındır', 'Bayraklı', 'Bergama', 'Beydağ', 'Bornova', 'Buca', 'Çeşme', 'Çiğli', 'Dikili', 'Foça', 'Gaziemir', 'Güzelbahçe', 'Karabağlar', 'Karaburun', 'Karşıyaka', 'Kemalpaşa', 'Kınık', 'Kiraz', 'Konak', 'Menderes', 'Menemen', 'Narlıdere', 'Ödemiş', 'Seferihisar', 'Selçuk', 'Tire', 'Torbalı', 'Urla'],
  'Bursa': ['Büyükorhan', 'Gemlik', 'Gürsu', 'Harmancık', 'İnegöl', 'İznik', 'Karacabey', 'Keles', 'Kestel', 'Mudanya', 'Mustafakemalpaşa', 'Nilüfer', 'Orhaneli', 'Orhangazi', 'Osmangazi', 'Yenişehir', 'Yıldırım'],
  'Antalya': ['Akseki', 'Aksu', 'Alanya', 'Demre', 'Döşemealtı', 'Elmalı', 'Finike', 'Gazipaşa', 'Gündoğmuş', 'İbradı', 'Kaş', 'Kemer', 'Kepez', 'Konyaaltı', 'Korkuteli', 'Kumluca', 'Manavgat', 'Muratpaşa', 'Serik'],
  'Adana': ['Aladağ', 'Ceyhan', 'Çukurova', 'Feke', 'İmamoğlu', 'Karaisalı', 'Karataş', 'Kozan', 'Pozantı', 'Saimbeyli', 'Sarıçam', 'Seyhan', 'Tufanbeyli', 'Yumurtalık', 'Yüreğir'],
  'Konya': ['Ahırlı', 'Akören', 'Akşehir', 'Altınekin', 'Beyşehir', 'Bozkır', 'Cihanbeyli', 'Çeltik', 'Çumra', 'Derbent', 'Derebucak', 'Doğanhisar', 'Emirgazi', 'Ereğli', 'Güneysınır', 'Hadim', 'Halkapınar', 'Hüyük', 'Ilgın', 'Kadınhanı', 'Karapınar', 'Karatay', 'Kulu', 'Meram', 'Sarayönü', 'Selçuklu', 'Seydişehir', 'Taşkent', 'Tuzlukçu', 'Yalıhüyük', 'Yunak'],
  'Gaziantep': ['Araban', 'İslahiye', 'Karkamış', 'Nizip', 'Nurdağı', 'Oğuzeli', 'Şahinbey', 'Şehitkamil', 'Yavuzeli'],
  'Mersin': ['Akdeniz', 'Anamur', 'Aydıncık', 'Bozyazı', 'Çamlıyayla', 'Erdemli', 'Gülnar', 'Mezitli', 'Mut', 'Silifke', 'Tarsus', 'Toroslar', 'Yenişehir'],
  'Kayseri': ['Akkışla', 'Bünyan', 'Develi', 'Felahiye', 'Hacılar', 'İncesu', 'Kocasinan', 'Melikgazi', 'Özvatan', 'Pınarbaşı', 'Sarıoğlan', 'Sarız', 'Talas', 'Tomarza', 'Yahyalı', 'Yeşilhisar'],
  'Eskişehir': ['Alpu', 'Beylikova', 'Çifteler', 'Günyüzü', 'Han', 'İnönü', 'Mahmudiye', 'Mihalgazi', 'Mihalıççık', 'Odunpazarı', 'Sarıcakaya', 'Seyitgazi', 'Sivrihisar', 'Tepebaşı'],
  'Diyarbakır': ['Bağlar', 'Bismil', 'Çermik', 'Çınar', 'Çüngüş', 'Dicle', 'Eğil', 'Ergani', 'Hani', 'Hazro', 'Kayapınar', 'Kocaköy', 'Kulp', 'Lice', 'Silvan', 'Sur', 'Yenişehir'],
  'Samsun': ['Alaçam', 'Asarcık', 'Atakum', 'Ayvacık', 'Bafra', 'Canik', 'Çarşamba', 'Havza', 'İlkadım', 'Kavak', 'Ladik', 'Ondokuzmayıs', 'Salıpazarı', 'Tekkeköy', 'Terme', 'Vezirköprü', 'Yakakent'],
  'Denizli': ['Acıpayam', 'Babadağ', 'Baklan', 'Bekilli', 'Beyağaç', 'Bozkurt', 'Buldan', 'Çal', 'Çameli', 'Çardak', 'Çivril', 'Güney', 'Honaz', 'Kale', 'Merkezefendi', 'Pamukkale', 'Sarayköy', 'Serinhisar', 'Tavas'],
  'Şanlıurfa': ['Akçakale', 'Birecik', 'Bozova', 'Ceylanpınar', 'Eyyübiye', 'Halfeti', 'Haliliye', 'Harran', 'Hilvan', 'Karaköprü', 'Siverek', 'Suruç', 'Viranşehir'],
  'Malatya': ['Akçadağ', 'Arapgir', 'Arguvan', 'Battalgazi', 'Darende', 'Doğanşehir', 'Doğanyol', 'Hekimhan', 'Kale', 'Kuluncak', 'Pütürge', 'Yazıhan', 'Yeşilyurt'],
  'Trabzon': ['Akçaabat', 'Araklı', 'Arsin', 'Beşikdüzü', 'Çarşıbaşı', 'Çaykara', 'Dernekpazarı', 'Düzköy', 'Hayrat', 'Köprübaşı', 'Maçka', 'Of', 'Ortahisar', 'Sürmene', 'Şalpazarı', 'Tonya', 'Vakfıkebir', 'Yomra']
};

const SPECIALTIES = [
  { value: 'general', label: 'Genel Bakım & Onarım', icon: Wrench },
  { value: 'installation', label: 'Montaj/Kurulum', icon: Wrench },
  { value: 'ac_charging', label: 'AC Şarj Sistemleri', icon: Zap },
  { value: 'dc_fast', label: 'DC Hızlı Şarj', icon: Zap },
  { value: 'software', label: 'Yazılım & OCPP', icon: Settings },
  { value: 'electrical', label: 'Elektrik Tesisatı', icon: Zap }
];

const TechnicianRegisterPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    // Kişisel Bilgiler
    full_name: '',
    phone: '',
    email: '',
    password: '',
    password_confirm: '',
    // Firma Bilgileri
    technician_type: 'subcontractor',
    company_name: '',
    tax_id: '',
    // Adres
    city: '',
    district: '',
    address: '',
    service_regions: [],
    // Uzmanlık
    specialties: ['general'],
    experience_years: '',
    profile_description: '',
    // Ödeme
    per_job_rate: 500,
    travel_allowance: 150,
    iban: '',
    // Sözleşme
    accept_terms: false,
    accept_privacy: false
  });

  const updateForm = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const toggleSpecialty = (specialty) => {
    const current = form.specialties;
    if (current.includes(specialty)) {
      if (current.length > 1) {
        updateForm('specialties', current.filter(s => s !== specialty));
      }
    } else {
      updateForm('specialties', [...current, specialty]);
    }
  };

  const toggleServiceRegion = (city) => {
    const current = form.service_regions;
    if (current.includes(city)) {
      updateForm('service_regions', current.filter(c => c !== city));
    } else {
      updateForm('service_regions', [...current, city]);
    }
  };

  const validateStep = (stepNum) => {
    switch(stepNum) {
      case 1:
        if (!form.full_name || form.full_name.length < 3) {
          toast.error('Ad Soyad en az 3 karakter olmalı');
          return false;
        }
        if (!form.phone || form.phone.length < 10) {
          toast.error('Geçerli bir telefon numarası girin');
          return false;
        }
        if (!form.email || !form.email.includes('@')) {
          toast.error('Geçerli bir email adresi girin');
          return false;
        }
        if (!form.password || form.password.length < 6) {
          toast.error('Şifre en az 6 karakter olmalı');
          return false;
        }
        if (form.password !== form.password_confirm) {
          toast.error('Şifreler eşleşmiyor');
          return false;
        }
        return true;
      case 2:
        if (!form.city) {
          toast.error('Lütfen bulunduğunuz ili seçin');
          return false;
        }
        if (form.service_regions.length === 0) {
          toast.error('En az bir hizmet bölgesi seçin');
          return false;
        }
        return true;
      case 3:
        if (form.specialties.length === 0) {
          toast.error('En az bir uzmanlık alanı seçin');
          return false;
        }
        return true;
      case 4:
        if (!form.accept_terms || !form.accept_privacy) {
          toast.error('Sözleşmeleri kabul etmelisiniz');
          return false;
        }
        return true;
      default:
        return true;
    }
  };

  const nextStep = () => {
    if (validateStep(step)) {
      setStep(step + 1);
    }
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const handleSubmit = async () => {
    if (!validateStep(4)) return;

    setLoading(true);
    try {
      // 1. Kullanıcı hesabı oluştur
      const userRes = await fetch(`${API_URL}/api/auth/register-technician`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: form.email,
          password: form.password,
          full_name: form.full_name,
          phone: form.phone,
          // Teknisyen bilgileri
          technician_type: form.technician_type,
          company_name: form.company_name || '',
          tax_id: form.tax_id || '',
          city: form.city || '',
          district: form.district || '',
          address: form.address || '',
          service_regions: form.service_regions || [],
          specialties: form.specialties || ['general'],
          experience_years: parseInt(form.experience_years) || 0,
          profile_description: form.profile_description || '',
          per_job_rate: parseFloat(form.per_job_rate) || 500,
          travel_allowance: parseFloat(form.travel_allowance) || 150,
          iban: form.iban || ''
        })
      });

      if (userRes.ok) {
        toast.success('Kayıt başarılı! Giriş yapabilirsiniz.');
        navigate('/login');
      } else {
        const err = await userRes.json();
        let errorMsg = err.detail || 'Kayıt yapılamadı';
        if (errorMsg.includes('email') || errorMsg.includes('Email')) {
          errorMsg = 'Bu email adresi zaten kayıtlı';
        }
        toast.error(errorMsg);
      }
    } catch (error) {
      console.error('Kayıt hatası:', error);
      toast.error('Sunucuya bağlanılamadı');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        {/* Logo & Title */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-r from-orange-500 to-amber-500 mb-4">
            <Wrench className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">HIMS Usta Platformu</h1>
          <p className="text-slate-400">EV şarj istasyonu bakım ve onarım uzmanı olarak kaydolun</p>
        </div>

        {/* Progress Steps */}
        <div className="flex items-center justify-center gap-2 mb-8">
          {[1, 2, 3, 4].map((s) => (
            <div key={s} className="flex items-center">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all ${
                step >= s 
                  ? 'bg-orange-500 text-white' 
                  : 'bg-slate-700 text-slate-400'
              }`}>
                {step > s ? <CheckCircle className="w-5 h-5" /> : s}
              </div>
              {s < 4 && (
                <div className={`w-12 h-1 mx-1 rounded ${
                  step > s ? 'bg-orange-500' : 'bg-slate-700'
                }`} />
              )}
            </div>
          ))}
        </div>

        {/* Form Card */}
        <div className="bg-slate-800/50 backdrop-blur-xl rounded-3xl border border-slate-700 p-8">
          {/* Step 1: Kişisel Bilgiler */}
          {step === 1 && (
            <div className="space-y-6">
              <div className="text-center mb-6">
                <User className="w-12 h-12 mx-auto text-orange-500 mb-2" />
                <h2 className="text-xl font-semibold text-white">Kişisel Bilgiler</h2>
                <p className="text-slate-400 text-sm">Giriş yapacağınız hesap bilgileri</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-300 mb-1">Ad Soyad *</label>
                  <input
                    type="text"
                    value={form.full_name}
                    onChange={(e) => updateForm('full_name', e.target.value)}
                    placeholder="Ahmet Yılmaz"
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-1">Telefon *</label>
                  <input
                    type="tel"
                    value={form.phone}
                    onChange={(e) => updateForm('phone', e.target.value)}
                    placeholder="0532 123 45 67"
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-1">Email *</label>
                  <input
                    type="email"
                    value={form.email}
                    onChange={(e) => updateForm('email', e.target.value)}
                    placeholder="usta@email.com"
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-1">Şifre *</label>
                  <input
                    type="password"
                    value={form.password}
                    onChange={(e) => updateForm('password', e.target.value)}
                    placeholder="En az 6 karakter"
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-1">Şifre Tekrar *</label>
                  <input
                    type="password"
                    value={form.password_confirm}
                    onChange={(e) => updateForm('password_confirm', e.target.value)}
                    placeholder="Şifreyi tekrar girin"
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                  />
                </div>
              </div>

              {/* Firma Tipi */}
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-2">Çalışma Şekli</label>
                <div className="grid grid-cols-3 gap-3">
                  {[
                    { value: 'subcontractor', label: 'Bireysel / Taşeron' },
                    { value: 'service_company', label: 'Servis Firması' },
                    { value: 'hims_team', label: 'HIMS Ekibi' }
                  ].map(type => (
                    <button
                      key={type.value}
                      type="button"
                      onClick={() => updateForm('technician_type', type.value)}
                      className={`p-3 rounded-xl border-2 text-sm font-medium transition-all ${
                        form.technician_type === type.value
                          ? 'border-orange-500 bg-orange-500/10 text-orange-400'
                          : 'border-slate-600 text-slate-400 hover:border-slate-500'
                      }`}
                    >
                      {type.label}
                    </button>
                  ))}
                </div>
              </div>

              {form.technician_type === 'service_company' && (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-300 mb-1">Firma Adı</label>
                    <input
                      type="text"
                      value={form.company_name}
                      onChange={(e) => updateForm('company_name', e.target.value)}
                      placeholder="Firma Ltd. Şti."
                      className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-300 mb-1">Vergi No</label>
                    <input
                      type="text"
                      value={form.tax_id}
                      onChange={(e) => updateForm('tax_id', e.target.value)}
                      placeholder="1234567890"
                      className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Step 2: Konum & Hizmet Bölgeleri */}
          {step === 2 && (
            <div className="space-y-6">
              <div className="text-center mb-6">
                <MapPin className="w-12 h-12 mx-auto text-orange-500 mb-2" />
                <h2 className="text-xl font-semibold text-white">Konum & Hizmet Bölgeleri</h2>
                <p className="text-slate-400 text-sm">Bulunduğunuz yer ve hizmet verebileceğiniz bölgeler</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-1">Bulunduğunuz İl *</label>
                  <select
                    value={form.city}
                    onChange={(e) => updateForm('city', e.target.value)}
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                  >
                    <option value="">Seçin...</option>
                    {CITIES.map(city => (
                      <option key={city} value={city}>{city}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-1">İlçe</label>
                  <select
                    value={form.district}
                    onChange={(e) => updateForm('district', e.target.value)}
                    disabled={!form.city}
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors disabled:opacity-50"
                  >
                    <option value="">{form.city ? 'Seçin...' : 'Önce il seçin'}</option>
                    {form.city && DISTRICTS[form.city]?.map(district => (
                      <option key={district} value={district}>{district}</option>
                    ))}
                    {form.city && !DISTRICTS[form.city] && (
                      <option value="">Bu il için ilçe verisi yok</option>
                    )}
                  </select>
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-300 mb-1">Açık Adres</label>
                  <input
                    type="text"
                    value={form.address}
                    onChange={(e) => updateForm('address', e.target.value)}
                    placeholder="Mahalle, sokak, bina no..."
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                  />
                </div>
              </div>

              {/* Hizmet Bölgeleri */}
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-2">
                  Hizmet Verebileceğiniz İller * 
                  <span className="text-slate-500 font-normal ml-2">({form.service_regions.length} seçili)</span>
                </label>
                <div className="max-h-48 overflow-y-auto bg-slate-900/30 rounded-xl p-3 border border-slate-700">
                  <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
                    {CITIES.map(city => (
                      <button
                        key={city}
                        type="button"
                        onClick={() => toggleServiceRegion(city)}
                        className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                          form.service_regions.includes(city)
                            ? 'bg-orange-500 text-white'
                            : 'bg-slate-800 text-slate-400 hover:bg-slate-700'
                        }`}
                      >
                        {city}
                      </button>
                    ))}
                  </div>
                </div>
                <p className="text-xs text-slate-500 mt-2">
                  Uzak bölgeler için yol masrafınızı belirleyebilirsiniz
                </p>
              </div>
            </div>
          )}

          {/* Step 3: Uzmanlık & Ücretlendirme */}
          {step === 3 && (
            <div className="space-y-6">
              <div className="text-center mb-6">
                <Star className="w-12 h-12 mx-auto text-orange-500 mb-2" />
                <h2 className="text-xl font-semibold text-white">Uzmanlık & Ücretlendirme</h2>
                <p className="text-slate-400 text-sm">Uzmanlık alanlarınız ve ücret bilgileri</p>
              </div>

              {/* Uzmanlık Alanları */}
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-2">Uzmanlık Alanları *</label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {SPECIALTIES.map(spec => {
                    const Icon = spec.icon;
                    return (
                      <button
                        key={spec.value}
                        type="button"
                        onClick={() => toggleSpecialty(spec.value)}
                        className={`flex items-center gap-3 p-4 rounded-xl border-2 text-left transition-all ${
                          form.specialties.includes(spec.value)
                            ? 'border-orange-500 bg-orange-500/10'
                            : 'border-slate-600 hover:border-slate-500'
                        }`}
                      >
                        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                          form.specialties.includes(spec.value) ? 'bg-orange-500' : 'bg-slate-700'
                        }`}>
                          <Icon className="w-5 h-5 text-white" />
                        </div>
                        <span className={form.specialties.includes(spec.value) ? 'text-orange-400' : 'text-slate-300'}>
                          {spec.label}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Deneyim */}
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-1">Kaç Yıl Deneyiminiz Var?</label>
                <input
                  type="number"
                  value={form.experience_years}
                  onChange={(e) => updateForm('experience_years', e.target.value)}
                  placeholder="5"
                  min="0"
                  max="50"
                  className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                />
              </div>

              {/* Ücretlendirme */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-1">Standart Müdahale Ücreti (₺)</label>
                  <input
                    type="number"
                    value={form.per_job_rate}
                    onChange={(e) => updateForm('per_job_rate', e.target.value)}
                    placeholder="500"
                    min="0"
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                  />
                  <p className="text-xs text-slate-500 mt-1">Her iş için alacağınız temel ücret</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-1">Uzak Bölge Ek Ücreti (₺)</label>
                  <input
                    type="number"
                    value={form.travel_allowance}
                    onChange={(e) => updateForm('travel_allowance', e.target.value)}
                    placeholder="150"
                    min="0"
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                  />
                  <p className="text-xs text-slate-500 mt-1">Uzak lokasyonlar için yol masrafı</p>
                </div>
              </div>

              {/* IBAN */}
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-1">IBAN Numaranız</label>
                <input
                  type="text"
                  value={form.iban}
                  onChange={(e) => updateForm('iban', e.target.value)}
                  placeholder="TR00 0000 0000 0000 0000 0000 00"
                  className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                />
              </div>

              {/* Profil Açıklaması */}
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-1">Kendinizi Tanıtın</label>
                <textarea
                  value={form.profile_description}
                  onChange={(e) => updateForm('profile_description', e.target.value)}
                  placeholder="Deneyimleriniz, başarılarınız, neden sizi tercih etmeliler..."
                  rows={3}
                  className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors resize-none"
                />
              </div>
            </div>
          )}

          {/* Step 4: Özet & Onay */}
          {step === 4 && (
            <div className="space-y-6">
              <div className="text-center mb-6">
                <Shield className="w-12 h-12 mx-auto text-orange-500 mb-2" />
                <h2 className="text-xl font-semibold text-white">Kayıt Özeti</h2>
                <p className="text-slate-400 text-sm">Bilgilerinizi kontrol edin ve onaylayın</p>
              </div>

              {/* Özet Kartları */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="p-4 bg-slate-900/50 rounded-xl border border-slate-700">
                  <h3 className="font-medium text-slate-300 mb-2 flex items-center gap-2">
                    <User className="w-4 h-4" /> Kişisel Bilgiler
                  </h3>
                  <p className="text-white">{form.full_name}</p>
                  <p className="text-slate-400 text-sm">{form.email}</p>
                  <p className="text-slate-400 text-sm">{form.phone}</p>
                </div>
                <div className="p-4 bg-slate-900/50 rounded-xl border border-slate-700">
                  <h3 className="font-medium text-slate-300 mb-2 flex items-center gap-2">
                    <MapPin className="w-4 h-4" /> Konum
                  </h3>
                  <p className="text-white">{form.city}{form.district ? `, ${form.district}` : ''}</p>
                  <p className="text-slate-400 text-sm">{form.service_regions.length} bölgede hizmet</p>
                </div>
                <div className="p-4 bg-slate-900/50 rounded-xl border border-slate-700">
                  <h3 className="font-medium text-slate-300 mb-2 flex items-center gap-2">
                    <Star className="w-4 h-4" /> Uzmanlık
                  </h3>
                  <p className="text-white">{form.specialties.length} alan</p>
                  <p className="text-slate-400 text-sm">{form.experience_years || 0} yıl deneyim</p>
                </div>
                <div className="p-4 bg-slate-900/50 rounded-xl border border-slate-700">
                  <h3 className="font-medium text-slate-300 mb-2 flex items-center gap-2">
                    <DollarSign className="w-4 h-4" /> Ücretlendirme
                  </h3>
                  <p className="text-white">{form.per_job_rate} ₺ / iş</p>
                  <p className="text-slate-400 text-sm">+{form.travel_allowance} ₺ yol masrafı</p>
                </div>
              </div>

              {/* Sözleşmeler */}
              <div className="space-y-3">
                <label className="flex items-start gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={form.accept_terms}
                    onChange={(e) => updateForm('accept_terms', e.target.checked)}
                    className="w-5 h-5 mt-0.5 rounded border-slate-600 text-orange-500 focus:ring-orange-500"
                  />
                  <span className="text-slate-300 text-sm">
                    <a href="/terms" target="_blank" className="text-orange-400 hover:underline">Hizmet Sözleşmesi</a>'ni 
                    okudum ve kabul ediyorum. *
                  </span>
                </label>
                <label className="flex items-start gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={form.accept_privacy}
                    onChange={(e) => updateForm('accept_privacy', e.target.checked)}
                    className="w-5 h-5 mt-0.5 rounded border-slate-600 text-orange-500 focus:ring-orange-500"
                  />
                  <span className="text-slate-300 text-sm">
                    <a href="/privacy" target="_blank" className="text-orange-400 hover:underline">Gizlilik Politikası</a>'nı 
                    okudum ve kabul ediyorum. *
                  </span>
                </label>
              </div>

              {/* Avantajlar */}
              <div className="p-4 bg-gradient-to-r from-orange-500/10 to-amber-500/10 rounded-xl border border-orange-500/20">
                <h3 className="font-medium text-orange-400 mb-2">HIMS Usta Platformu Avantajları</h3>
                <ul className="text-sm text-slate-300 space-y-1">
                  <li>✓ Türkiye genelinde iş fırsatları</li>
                  <li>✓ Güvenli ödeme sistemi</li>
                  <li>✓ Müşteri değerlendirme ve puanlama</li>
                  <li>✓ Teknik destek ve eğitimler</li>
                </ul>
              </div>
            </div>
          )}

          {/* Navigation Buttons */}
          <div className="flex items-center justify-between mt-8 pt-6 border-t border-slate-700">
            {step > 1 ? (
              <button
                type="button"
                onClick={prevStep}
                className="flex items-center gap-2 px-6 py-3 text-slate-400 hover:text-white transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
                Geri
              </button>
            ) : (
              <Link to="/login" className="flex items-center gap-2 px-6 py-3 text-slate-400 hover:text-white transition-colors">
                <ArrowLeft className="w-5 h-5" />
                Giriş Yap
              </Link>
            )}

            {step < 4 ? (
              <button
                type="button"
                onClick={nextStep}
                className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-orange-500 to-amber-500 text-white font-medium rounded-xl hover:opacity-90 transition-opacity"
              >
                Devam
                <ArrowRight className="w-5 h-5" />
              </button>
            ) : (
              <button
                type="button"
                onClick={handleSubmit}
                disabled={loading}
                className="flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white font-medium rounded-xl hover:opacity-90 transition-opacity disabled:opacity-50"
              >
                {loading ? 'Kaydediliyor...' : 'Kaydı Tamamla'}
                <CheckCircle className="w-5 h-5" />
              </button>
            )}
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-slate-500 text-sm mt-6">
          Zaten hesabınız var mı? <Link to="/login" className="text-orange-400 hover:underline">Giriş yapın</Link>
        </p>
      </div>
    </div>
  );
};

export default TechnicianRegisterPage;
